import React from 'react';
import { searchResultsProductsPropTypes } from './SearchResultsProductsPropTypes';
import Picture from '@Theme/natucare/components/Picture/Picture';
import * as styles from './SearchResultsProducts.module.scss';
const renderStarIcon = () => /*#__PURE__*/React.createElement("svg", {
  className: styles.rootProductStarIcon,
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  "aria-hidden": "true",
  focusable: "false"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.814 1.05c.154-.312.231-.468.336-.518a.334.334 0 0 1 .287 0c.105.05.181.206.335.518l1.46 2.958a.73.73 0 0 0 .102.174c.03.031.064.057.104.075.044.02.095.028.196.043l3.266.477c.344.05.516.076.595.16.07.073.102.173.089.273-.015.115-.14.236-.389.478L9.833 7.99c-.074.072-.11.108-.134.15a.334.334 0 0 0-.04.123c-.006.048.003.099.02.2l.558 3.25c.058.343.088.514.033.616a.334.334 0 0 1-.233.169c-.114.02-.268-.06-.575-.222l-2.92-1.535a.73.73 0 0 0-.184-.082.33.33 0 0 0-.129 0c-.048.01-.093.034-.184.082l-2.92 1.535c-.308.162-.462.243-.575.222a.334.334 0 0 1-.233-.17c-.055-.1-.026-.272.033-.615l.558-3.25a.73.73 0 0 0 .02-.2.334.334 0 0 0-.04-.123c-.024-.042-.06-.078-.134-.15L.39 5.69c-.248-.243-.373-.364-.388-.48-.013-.099.02-.2.088-.272.08-.084.252-.11.596-.16L3.953 4.3c.101-.015.152-.022.196-.043a.334.334 0 0 0 .104-.075c.033-.036.056-.082.101-.174l1.46-2.958Z"
}));
const formatRatingValue = value => {
  if (!Number.isFinite(value)) {
    return null;
  }
  return value % 1 === 0 ? value.toString() : value.toFixed(1);
};
const renderStars = rating => {
  const safeRating = Math.max(0, Math.min(5, Math.round(rating || 0)));
  return Array.from({
    length: 5
  }, (_, index) => /*#__PURE__*/React.createElement("span", {
    key: index,
    className: `${styles.rootProductStar} ${index < safeRating ? styles.rootProductStarFilled : ''}`,
    "aria-hidden": "true"
  }, renderStarIcon()));
};
const SearchResultsProducts = ({
  items,
  button
}) => {
  const hasItems = (items === null || items === void 0 ? void 0 : items.length) > 0;
  if (!hasItems) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, hasItems && /*#__PURE__*/React.createElement("div", {
    className: styles.rootWrapper
  }, items.map((item, index) => {
    var _item$picture, _item$picture2;
    const pictureData = {
      xs: {
        src: (_item$picture = item.picture) === null || _item$picture === void 0 ? void 0 : _item$picture.src
      },
      alt: (_item$picture2 = item.picture) === null || _item$picture2 === void 0 ? void 0 : _item$picture2.alt
    };
    return /*#__PURE__*/React.createElement("a", {
      href: item.href,
      className: styles.rootTileLink,
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.rootPictureWrapper
    }, /*#__PURE__*/React.createElement(Picture, Object.assign({}, pictureData, {
      pictureClassname: styles.rootPicture,
      imgClassname: styles.rootImage
    })), item.labels && /*#__PURE__*/React.createElement("div", {
      className: styles.rootPictureLabelWrapper
    }, item.labels.map((label, labelIndex) => /*#__PURE__*/React.createElement("span", {
      className: styles.rootPictureLabel,
      key: labelIndex
    }, label)))), /*#__PURE__*/React.createElement("div", {
      className: styles.rootProduct
    }, Number.isFinite(item.rating) && /*#__PURE__*/React.createElement("div", {
      className: styles.rootProductRating
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.rootProductStars
    }, renderStars(item.rating)), /*#__PURE__*/React.createElement("span", {
      className: styles.rootProductRatingValue
    }, formatRatingValue(item.rating))), /*#__PURE__*/React.createElement("span", {
      className: styles.rootProductTitle
    }, item.title), item.price && /*#__PURE__*/React.createElement("div", {
      className: styles.rootProductPriceWrapper
    }, /*#__PURE__*/React.createElement("span", {
      className: `${styles.rootProductPrice} ${styles.rootProductPriceRegular}`
    }, item.price.regular.toFixed(2), " ", item.price.currency))));
  })), button && hasItems && /*#__PURE__*/React.createElement("a", {
    href: button.href,
    className: styles.rootButton
  }, button.label));
};
export default SearchResultsProducts;